import styled from 'styled-components';

import { PAGES } from 'constants/pages';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';

import { AuditList } from './components/AuditList';

export const Audit = () => (
    <Container>
        <Header>
            <HeaderTitle>
                <PageTitle page={PAGES.audit} />
            </HeaderTitle>
        </Header>
        <Content>
            <AuditList />
        </Content>
    </Container>
);

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
    color: ${({ theme }) => theme.textColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;
